import React from 'react'

const AppleMusicProgress = ({theme = 'dark'}) => {
    return (
        <apple-music-volume theme={theme}></apple-music-volume>
    )
}

export default AppleMusicProgress